import { Injectable } from '@angular/core';
import * as moment from 'moment';
// import { AccountBasicData } from '../models/account/account-basic-data.model';


@Injectable({
  providedIn: 'root'
})
export class ComplaintAndMetereadingService {
  public operationId:any;
  public token:any;
  constructor(
    // private account:AccountBasicData
  ) { }

  generateToken(usercode:any)
  {
    let date = new Date();
    let inputDate = moment(date).format('DDMMYYYYHHMMSS').toString();
    let inputUserCode =  usercode;
    let origin = "OV";
    this.token = inputDate + inputUserCode + origin;

    return this.token
  }
  getToken()
  {   
    
  
    if(this.token != null)
    {
      return true
    }
    else
    {
      return false
    }   
  }
  saveOperationId(operationId:any)
  {
    
    this.operationId = operationId;

    return this.operationId;
  }
  getOperationId()
  {

    return this.operationId;
  }
}